import React from 'react';

const Logo = props => {
  const { height, width } = props;
  return (
    <svg
      width={width ? width : height ? height * (161 / 236) : 161}
      height={height ? height : width ? width * (236 / 161) : 236}
      viewBox="0 0 161 236"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Screens"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Splash-screen---Velkommen"
          transform="translate(-401.000000, -365.000000)"
        >
          <g id="Group" transform="translate(405.500000, 370.148886)">
            <ellipse
              id="Oval"
              fill="#E5EEF3"
              cx="78.4362573"
              cy="219"
              rx="54.6256507"
              ry="11"
            ></ellipse>
            <path
              d="M68.579991,195.345944 C12.4707802,114.004233 2.05587144,105.656087 2.05587144,75.7617844 C2.05587144,34.8130817 35.2511244,1.61782872 76.1998271,1.61782872 C117.14853,1.61782872 150.343783,34.8130817 150.343783,75.7617844 C150.343783,105.656087 139.928874,114.004233 83.8196632,195.345944 C80.1375662,200.665001 72.2617018,200.664615 68.579991,195.345944 Z M76.1998271,106.655099 C93.2618187,106.655099 107.093142,92.823776 107.093142,75.7617844 C107.093142,58.6997927 93.2618187,44.8684695 76.1998271,44.8684695 C59.1378355,44.8684695 45.3065122,58.6997927 45.3065122,75.7617844 C45.3065122,92.823776 59.1378355,106.655099 76.1998271,106.655099 Z"
              id="Shape"
              fill="#C57ABF"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path-13"
              fill="#B3DCDE"
              points="108.811023 162.582808 91.4729999 134.489689 116.191152 100.47646 102.00746 87.8120718 104.555871 77.1248752 104.555871 68.0807058 97.1998271 57.2006644 85.6542638 48.453674 84.0558714 45.6178287 90.5558714 25.3281597 107.055871 34.6178287 123.782225 45.6178287 141.826432 36.9440238 147.248986 45.6178287 150.343783 61.1178287 153.413158 75.7617844 153.413158 85.7667151 150.343783 99.5684185 141.826432 115.014136"
            ></polygon>
            <polygon
              id="Path-14"
              fill="#719BBB"
              points="97.0558714 1.61782872 90.5558714 23.6178287 123.824569 44.8684695 141.826432 36.9440238 135.248684 25.3281597 118.199827 11.2157964 101.451012 4.01862279"
            ></polygon>
            <polygon
              id="Path-15"
              fill="#98C3D1"
              points="51.8387185 173.449563 94.6300948 145.778806 89.1628626 133.539912 117.0035 100.47646 103.123512 87.7434827 93.0353191 99.5684185 81.0648953 104.072823 67.2431192 102.024395 58.5409733 99.5684185 20.6328474 133.539912"
            ></polygon>
            <polygon
              id="Path-16"
              fill="#DAB3E6"
              points="2.05587144 96.2076778 27.0498293 85.7667151 41.8027511 113.370122 56.5837418 99.5684185 49.2230368 85.7667151 49.2230368 70.9044413 49.2230368 61.1178287 7.74249236 40.3054269 2.05587144 52.2586304 3.92628581e-16 75.7617844 0 92.2667151"
            ></polygon>
            <path
              d="M51.8387185,61.1178287 L58.5409733,54.3493909 L72.1998271,48.0245355 L80.4826502,45.6178287 L82.2674952,46.2029719 L95.1207879,3.17621514 L87.6558899,0.677608025 L72.1998271,-3.55271368e-15 C61.1064532,2.11747676 55.5597662,3.17621514 55.5597662,3.17621514 C55.5597662,3.17621514 51.8568943,4.46339981 44.4511504,7.03776915 L32.4897835,12.1207957 C27.3059983,17.3236502 24.5467331,19.9250775 24.2119878,19.9250775 C23.8772425,19.9250775 20.0526676,24.2174969 12.7382633,32.8023358 L9.73019391,39.320206 L21.1509621,46.2029719 L48.8633136,59.9708228 L51.8387185,61.1178287 Z"
              id="Path-17"
              fill="#E5A7A7"
            ></path>
            <polygon
              id="Path-18"
              fill="#8197B2"
              points="51.8387185 175.94157 97.0558714 144.763921 108.811023 162.582808 101.374972 175.94157 82.5296146 199.335092 72.1998271 199.335092 63.503137 192.569627"
            ></polygon>
            <path
              d="M96.5558714,1.61782872 L84.5558714,44.8684695"
              id="Line"
              stroke="#FFFFFF"
              strokeWidth="6"
              strokeLinecap="square"
            ></path>
            <polyline
              id="Path-3"
              stroke="#FFFFFF"
              strokeWidth="6"
              points="100.899994 85.7667151 116.191152 100.47646 90.0558714 133.539912 108.811023 162.582808 133.061908 172.049507"
            ></polyline>
            <path
              d="M97.0558714,143.617829 L48.0558714,175.617829"
              id="Path-8"
              stroke="#FFFFFF"
              strokeWidth="6"
            ></path>
            <polyline
              id="Path-9"
              stroke="#FFFFFF"
              strokeWidth="6"
              points="90.5558714 23.6178287 123.782225 45.6178287 143.451128 36.7544426"
            ></polyline>
            <path
              d="M51.8387185,64.2118339 L7.74249236,40.3054269"
              id="Path-10"
              stroke="#FFFFFF"
              strokeWidth="6"
            ></path>
            <path
              d="M58.5409733,100.47646 L20.6328474,133.539912"
              id="Path-11"
              stroke="#FFFFFF"
              strokeWidth="6"
            ></path>
            <polyline
              id="Path-12"
              stroke="#FFFFFF"
              strokeWidth="6"
              points="41.8027511 113.370122 27.0498293 85.7667151 2.05587144 96.7430235"
            ></polyline>
            <path
              d="M71.0480672,193.640481 C71.0485337,193.641157 71.0490001,193.641833 71.0494665,193.642509 L71.0466643,193.638454 C71.0471319,193.63913 71.0475996,193.639805 71.0480675,193.640481 Z M66.1133177,197.053435 L66.1105155,197.049379 C57.2729803,184.237575 25.2338815,138.586982 19.5026053,130.002533 C8.76643584,113.921628 3.7357557,104.373194 1.19530163,94.7268058 C-0.313222765,88.9987701 -0.944128559,83.1588994 -0.944128559,75.7617844 C-0.944128559,33.1562274 33.5942702,-1.38217128 76.1998271,-1.38217128 C118.805384,-1.38217128 153.343783,33.1562274 153.343783,75.7617844 C153.343783,83.1588994 152.712877,88.9987701 151.204353,94.7268058 C148.663898,104.373194 143.633218,113.921628 132.897049,130.002533 C127.165773,138.586982 95.1266739,184.237575 86.2863107,197.053472 C81.4113371,204.095725 70.9880391,204.095551 66.1133177,197.053435 Z M76.1998271,103.655099 C91.6049645,103.655099 104.093142,91.1669217 104.093142,75.7617844 C104.093142,60.356647 91.6049645,47.8684695 76.1998271,47.8684695 C60.7946897,47.8684695 48.3065122,60.356647 48.3065122,75.7617844 C48.3065122,91.1669217 60.7946897,103.655099 76.1998271,103.655099 Z"
              id="Shape"
              stroke="#FFFFFF"
              strokeWidth="6"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Logo;
